<template>
	<div class="innerBox">
		<div class="row">
			<div class="col-md-10">
				<h2>Isi Gambar Mobil  - {{form_code}}</h2>
			</div>
			<div class="col-md-2">
				<button type="button" class="btn btn-sm btn-primary w-100" @click="back">< Kembali</button>
			</div>
		</div>
		
		<div class="row mt-5">
			<div class="col-md-10">
				<h4 class="mt-3">Foto Mobil</h4>
			</div>
			<div class="col-md-2 mt-2">
				<button type="button" class="btn btn-sm  w-100" :class="{'btn-info' : !hide.imageList , 'btn-warning' : hide.imageList}" @click="hide.imageList = !hide.imageList">{{!hide.imageList ? 'Perlihatkan' : 'Sembunyikan'}} Foto</button>
			</div>
		</div>
		
		<hr>
		<template v-if="hide.imageList">
			<div class="row" v-if="imageList.length > 0 ">
				<div class="col-md-2" v-for="image in imageList">
					<img :src="env.baseImage + '/' + image" style="width:100%;max-height:200px"
						@click="previewImage(image)"
					/>
					<button class="btn btn-danger w-100 btn-sm mt-1 mb-1" type="button" style="z-index:2" @click="deleteImagePrompt(image)">-</button>
				</div>
			</div>
			<div v-else class="text-center mt-4">
				<h4>Gambar Mobil Belum Tersedia</h4>
			</div>
		</template>

		<!-- {{postCondition}} {{imageList}} -->

		<div class="row mt-5">
			<div class="col-md-10">
				<h4 class="mt-3">Foto Epoxy</h4>
			</div>
			<div class="col-md-2 mt-2">
				<button type="button" class="btn btn-sm  w-100" :class="{'btn-info' : !hide.epoxy , 'btn-warning' : hide.epoxy}" @click="hide.epoxy = !hide.epoxy">{{!hide.epoxy ? 'Perlihatkan' : 'Sembunyikan'}} Foto</button>
			</div>
		</div>

		<hr>

		<template v-if="hide.epoxy">
			<div class="row" v-if="woProgress">
				<template v-for="name in Object.keys(woProgress)">
					<!-- {{name}} -->
					<div :class="'col-md-' + (woProgress[name].length * 3)" class="mt-2">
						{{name}}

						<div class="row">
							<div class="col" v-for="image in woProgress[name]">
								<!-- {{image}} -->
								<img :src="env.baseImage + '/' + image" style="width:100%;max-height:200px;"
									@click="previewImage(image)"
								/>
								
							</div>
						</div>
					</div>
				</template>
			</div>
			<div v-else class="text-center mt-4">
				<h4>Gambar Epoxy Belum Tersedia</h4>
			</div>
		</template>

		<div class="row mt-5">
			<div class="col-md-10">
				<h4 class="mt-3">Foto Tutup WO</h4>
			</div>
			<div class="col-md-2 mt-2">
				<button type="button" class="btn btn-sm  w-100" :class="{'btn-info' : !hide.post_condition , 'btn-warning' : hide.post_condition}" @click="hide.post_condition = !hide.post_condition">{{!hide.post_condition ? 'Perlihatkan' : 'Sembunyikan'}} Foto</button>
			</div>
		</div>

		<hr>

		<!-- {{postCondition}} -->
		<template v-if="hide.post_condition">
			<div class="row" v-if="postCondition">
				<template v-for="name in Object.keys(postCondition)">
					<!-- {{name}} -->
					<div :class="'col-md-' + (postCondition[name].image ? postCondition[name].image.length : 0 * 3)" class="mt-2" v-if="postCondition[name].image">
						{{toCapitalizedWords(name)}}

						<div class="row" v-if="postCondition[name].image">
							<div class="col" v-for="image in postCondition[name].image">
								<img :src="env.baseImage + '/' + image" style="width:100%;max-height:200px"
									@click="previewImage(image)"
								/>
							</div>
						</div>
					</div>
				</template>
			</div>
			<div v-else class="text-center mt-4">
				<h4>Gambar Tutup WO Belum Tersedia</h4>
			</div>
		</template>

		



		<div class="mt-5 text-center p-20 border border-secondary rounded">
			<div class=" h-100  align-middle" @drop.prevent="addFile" @dragover.prevent style="min-height:300px">
				<div style="color:#ccc">
					<img src="@/assets/img/UploadLogo.png" />
					<br>
					<br>
					<span>Drop Files Here</span>
					<br>
					<span>Or</span>
					<br>
					<br>
					<input type="file" class="btn btn-secondary w-50" @change="addFile" placeholder="Select Files" multiple>
				</div>
				
			</div>
		</div>
		<template v-if="url.length > 0"> 
			<h4 class="mt-4">Foto Yang Akan Diunggah</h4>
			<hr>
			<div class="row" >
				<div class="col-md-2 text-center" v-for="(pic , index) in url">
					<!-- {{pic}} -->
					<img :src="pic" style="width:100%;max-height:200px"/>
					<button class="mt-2 btn btn-danger" @click="url.splice(index , 1)">Delete</button>
				</div>
			</div>
		</template>

		<b-progress :value="value" :max="maxValue" show-progress animated height="2rem" v-if="(typeof value != 'object')">
			<b-progress-bar :value="value" >
				<span>Progress: <strong>{{ value }} / {{ maxValue }}</strong></span>
			</b-progress-bar>
		</b-progress>

		<div class="text-right mt-3">
			<button class="btn btn-success" style="min-width:200px;" :disabled="url.length == 0" @click="updateWorkOrder">Unggah Gambar</button>
		</div>

		<preview-image
			v-if="curImage"
			@closeModal="curImage = null"
			:image="curImage"
		></preview-image>
			
	</div>
</template>

<script>
import env from '@/env'

import PreviewImage from "@/components/modal/previewImage.vue";

export default {
	components : {
		PreviewImage
	},
	data () {
		return {
			form_code : null,
			imageList : [],
			woProgress : null,
			file : null,
			url : [],
			env,
			curImage : null,
			postCondition : null,
			hide : {
				imageList : true,
				epoxy : true,
				post_condition : true
			},
			value : null,
			maxValue : 1
		}
	},
	mounted () {
		this.form_code = this.$route.params.form_code
		this.loadWorkOrder()
		this.getWoProgress()
	},
	methods : {
		back () {
			this.$router.push({
				name: 'WorkOrderDetailV2',
				params: { type: "wo" },
				query: { wo: this.form_code.replace(/"/g, "") }
			});
		},
		previewImage (image) {
			this.curImage = image
		},
		loadWorkOrder() {
			this.$http
				.get(`/api/v1/workorder/${this.form_code}/detail`)
				.then(async resp => {
					// console.log(resp.data.data)
					let data = resp.data.data
					this.imageList = data.condition && data.condition.imageList ? data.condition.imageList : []
					// console.log(data.conditon , data.condition.imageList)

					this.postCondition = data.post_condition ? data.post_condition.figureOverall : {};
					
				})
		},
		getWoProgress() {
			this.$http.get(`/api/v1/workorder/steps/${this.form_code}`)
				.then((resp) => {
					let data = Object.assign([] , resp.data.data.filter(x => x.step.id == 6 && x.status != -1));
					data = data.filter(x => x.estimations.length > 0 && (x.estimations[0].type == 'R/C' || x.estimations[0].type == 'Special Repair'))
					console.log(data)

					let woProgressList = {}

					for(var i = 0 ; i < data.length ; i++) {
						let curData = data[i]

						curData.name = `Epoxy #${curData.id} - ${curData.estimations[0].sparepart.sparepart_variants.name} - ${curData.estimations[0].extension}`
						woProgressList[curData.name] = curData.img ? curData.img : []
					}

					// console.log(woProgressList)

					this.woProgress = woProgressList
				})
				.catch((err) => {
					console.log(err)
				})
		},
		addFile(data) {
			this.file = data.dataTransfer ? data.dataTransfer.files : data.target.files;
			
			// console.log(file)
            
            for(var i = 0 ; i < this.file.length ; i ++) {
				// var size  = file[i].size / 1024 / 1024;
				// this.$emit('uploadDocument' , file[i], size)
				let blobURL = URL.createObjectURL(this.file[i])

				this.url.push(blobURL)
            }

			// this.maxValue = this.url.length;
		},
		async uploadAllImage() {
			let image = []

			this.loading = true
			let length = this.file.length
			this.value = 0
			this.maxValue = length;

			for(var i = 0 ; i < this.file.length ;  i++) {
				let vm = this
				try {
					if(!this.file[i].type.includes('image')) throw new Error('Not An Image File Type');

					let resp = await fetch(URL.createObjectURL(this.file[i]))

					let blob = await resp.blob()

					let file = new File([blob], 'test.png');
					
					let formData = new FormData()

					formData.append('work_order', file)

					let response = await vm.$http.post(env.urlStart + '/api/v1/workorder/image', formData, {headers : {"Content-Type":'multipart/form-data'}})

					image.push(response.data.data.filename)

					console.log(image)
					if(this.value == length) {
						this.loading = false
					}
					else {
						this.value++
					}
				}
				catch(err) {
					this.$store.dispatch('triggerAlert' , [false , err])
					console.log(err)
					return false
				}
				
			}
			
			return image
		},
		deleteImage(image) {

			this.$swal()
			this.$http.delete('/api/v1/workorder/fields/image/' + this.form_code + '?image=' + image)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Selesai Hapus Gambar'])
				this.loadWorkOrder()
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong When Deleting This Image' , err])
			})
		},
		deleteImagePrompt(image) {
			this.$swal
				.fire({
					title: "Apakah anda yakin?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Saya Yakin",
					cancelButtonText: "Kembali",
				})
				.then((result) => {
					if (result.value) {
						this.deleteImage(image)
					}
				});

		},
		updateWorkOrder : async function () {
			let data = {
				condition : {}
			}

			let image = await this.uploadAllImage()
			console.log(image)
			if(!image) return
			// console.log(image)

			data.condition.imageList = this.imageList.concat(image)
			console.log(data.condition.imageList)
			let vm = this
			this.$http.patch('/api/v1/workorder/' + vm.form_code , {data : data})
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Upload Gambar Selesai'])

				this.$router.push({
					name: 'WorkOrderDetailV2',
					params: { type: "wo" },
					query: { wo: vm.form_code.replace(/"/g, "") }
				});

			})
			.catch((err) => {
				console.log(err)
			})
			

			
		}
	}
}
</script>